import { Box, styled } from "@mui/material";

type Variant = "xs" | "small" | "medium" | "large";
type Props = {
  readonly profilePicture: string;
  readonly variant?: Variant;
};

const getDimensionsByVariant = (variant: Variant): number => {
  switch (variant) {
    case "xs":
      return 28;
    case "small":
      return 32;
    case "medium":
      return 40;
    case "large":
      return 48;
  }
};

const StyledBox = styled(Box)<Required<Pick<Props, "variant">>>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => getDimensionsByVariant(props.variant)}px;
  height: ${(props) => getDimensionsByVariant(props.variant)}px;
  border: 1px solid ${(props) => props.theme.colors.white};
  border-radius: 50%;
  cursor: pointer;
`;

export const UserProfilePictureIcon: React.FC<Props> = ({ profilePicture, variant = "medium" }) => {
  const srcValue = profilePicture;

  return (
    <StyledBox variant={variant}>
      <Box component="img" sx={{ height: getDimensionsByVariant(variant), borderRadius: 50 }} alt="Profilový obrázek" src={srcValue} />
    </StyledBox>
  );
};
